module.exports = __webpack_public_path__ + "static/lodastack-title-logo_128x128-fef0eada1e413c3a31f13a43ffff6acd.png";